var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwardsbg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 216,
    viewBox: "0 0 585 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_56_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 60.6474,
    width: 564.514,
    height: 84.9711,
    rx: 42.4855,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.769,
    cy: 53.8497,
    rx: 107.186,
    ry: 49.8497,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.026,
    cy: 158.081,
    rx: 114.332,
    ry: 41.9191,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.975,
    cy: 55.5491,
    rx: 75.0303,
    ry: 39.0867,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 447.036,
    cy: 55.5492,
    rx: 76.8167,
    ry: 27.7572,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.062,
    cy: 148.451,
    rx: 70.5642,
    ry: 44.7514,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.04,
    cy: 158.081,
    rx: 100.04,
    ry: 35.1214,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_56_5",
    x: 0,
    y: 0,
    width: 584.514,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.392157 0 0 0 0 0.713726 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_5",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardsbg);
export default __webpack_public_path__ + "static/media/awardsbg.ed972821eb2d422f9ff36cdad67da048.svg";
export { ForwardRef as ReactComponent };